var _path, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongXiaoxi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14l-.3.4a.5.5 0 00.6 0L8 14zm-2-1.5l.3-.4-.133-.1H6v.5zm4 0V12h-.167l-.133.1.3.4zm-7.5-9h11v-1h-11v1zm11 0V12h1V3.5h-1zM2.5 12V3.5h-1V12h1zm5.8 1.6l-2-1.5-.6.8 2 1.5.6-.8zM6 12H2.5v1H6v-1zm7.5 0H10v1h3.5v-1zm-3.8.1l-2 1.5.6.8 2-1.5-.6-.8zM1.5 12a1 1 0 001 1v-1h-1zm12 0v1a1 1 0 001-1h-1zm0-8.5h1a1 1 0 00-1-1v1zm-11-1a1 1 0 00-1 1h1v-1z",
    fill: "#3F465C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 7.75,
    r: 0.75,
    fill: "#3F465C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.75,
    cy: 7.75,
    r: 0.75,
    fill: "#3F465C"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.25,
    cy: 7.75,
    r: 0.75,
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_xiaoxi.cbc19d43.svg";
export { SvgTongyongXiaoxi as ReactComponent };